import moment from 'moment';
import { Box, Button, Stack } from '@mui/material';
import { IHistoryRecord } from 'app/app/editor/useHistory';
import { useAppBuilderContext } from 'app/app/editor/context';
import useBundleTranslation from 'i18n';
import React from 'react';

export default function RecoverHistory() {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();

    const recoverHistory = (history: IHistoryRecord) => {
        ctx.setPage(history.page, false);
        ctx.history.selectHistoryRecord(0);
    };

    const history = ctx.history.getByDate(ctx.history.selectedHistoryRecord);
    if (!history) {
        return null;
    }

    return (
        <Box sx={{ width: '300px' }}>
            <Stack spacing={1.5} direction={'row'} sx={{ pt: 1, justifyContent: 'center' }}>
                {t('history.recover_from')}: {moment(history.date).format('MMMM DD, hh:mm:ss')}
            </Stack>
            <Stack spacing={1.5} direction={'row'} sx={{ pt: 1, justifyContent: 'center' }}>
                <Button onClick={() => recoverHistory(history)}>{t('history.recover')}</Button>
                <Button variant={'outlined'} color="neutral" onClick={() => ctx.history.selectHistoryRecord(0)}>
                    {t('cancel')}
                </Button>
            </Stack>
        </Box>
    );
}
